export const environment = {
  production: true,
  apiUrl: 'https://api.ukixx.yukari.viperdev.io/',
  dsnSentry: 'https://dea951d398a0433c94ed65138e17d6a5@sentry.viperdev.io/28',
  oneSignalAppId: '0317927b-23bb-4bb5-b890-10df7c40d39f',
  googleProjectNumber: '248639660813',
};
